import type React from "react";
import { MeshBackground } from "./mesh-background";

type PageLayoutProps = {
  children: React.ReactNode;
  id?: string;
  as?: "main" | "div";
  className?: string;
  /** Emerald marks the ATS booster; every other screen keeps the violet default. */
  variant?: "violet" | "emerald";
};

/** Every app screen sits on the same blurred backdrop, so the pages read as one product. */
export function PageLayout({
  children,
  id,
  as: As = "main",
  className,
  variant = "violet",
}: PageLayoutProps) {
  return (
    <As id={id} className={`relative mx-auto w-full px-4 py-8 pb-16 ${className || "max-w-7xl"}`}>
      <MeshBackground variant={variant} />
      {children}
    </As>
  );
}
